class SWRError extends Error {
  constructor(public message: string, public status: number) {
    super(message);
  }
}

/**
 * SWR fetch that will convert the resulting json data using the handler
 * @param handler function to convert the json response to a certain output.
 * @returns
 */
export function jsonFetcherWithHandler<T>(handler: (data: any) => T) {
  return (endpoint: string) => {
    const url = `${process.env.NEXT_PUBLIC_API}${endpoint}`;
    return fetch(url, { credentials: 'include' }).then(async (res) => {
      if (res.status !== 200) {
        throw new SWRError('Error fetching data', res.status);
      }
      const data: any = await res.json();
      return handler(data);
    });
  };
}

/**
 * SWR fetch that will convert the resulting json data using the handler
 * @param handler function to convert the json response to a certain output.
 * @returns
 */
export function cachedApiFetcher<T>(handler: (data: any) => T) {
  return (endpoint: string) => {
    const url = `${process.env.NEXT_PUBLIC_CACHED_API}${endpoint}`;
    return fetch(url).then(async (res) => {
      if (res.status !== 200) {
        throw new SWRError('Error fetching data', res.status);
      }
      const data: any = await res.json();
      return handler(data);
    });
  };
}
